// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Lh0_","label":"styles_label__J-Irm"};